module.exports = __webpack_public_path__ + "static/media/alpha-book.a6aa7fd2.svg";